import * as bootstrap from 'bootstrap';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollSmoother } from "gsap/ScrollSmoother";

gsap.registerPlugin(ScrollTrigger, ScrollSmoother);

ScrollSmoother.create({
    smooth: 1,               // how long (in seconds) it takes to "catch up" to the native scroll position
    effects: true,           // looks for data-speed and data-lag attributes on elements
});

// navbar dropdown hover
function navbarDropdownHover() {
    if (window.innerWidth > 992) {
        document.querySelectorAll('.navbar .nav-item').forEach(function(everyitem){
            everyitem.addEventListener('mouseover', function(e){
                let el_link = this.querySelector('a[data-bs-toggle]');
    
                if(el_link != null){
                    let nextEl = el_link.nextElementSibling;
                    el_link.classList.add('show');
                    nextEl.classList.add('show');
                }
            });
            
            everyitem.addEventListener('mouseleave', function(e){
                let el_link = this.querySelector('a[data-bs-toggle]');
    
                if(el_link != null){
                    let nextEl = el_link.nextElementSibling;
                    el_link.classList.remove('show');
                    nextEl.classList.remove('show');
                }
            })
    
            everyitem.addEventListener('click', function(e){
                let el_link = this.querySelector('a[data-bs-toggle]');
                let linkHref = el_link.href;
                window.location = linkHref;
            })
        });
    }
}

// fade up animation on scroll
function animationOnHover() {
    const fadeUpEl = document.querySelectorAll('.fade-up');
    fadeUpEl.forEach((item) => {
        gsap.fromTo(item, {
            y: 100,
            autoAlpha: 0,
        }, {
            y: 0,
            autoAlpha: 1,
            duration: 0.8,
            ease: "ease",
            scrollTrigger: {
                trigger: item,
                start: "top-=100px bottom-=150px",
                // markers: true,
            }
        })
    })
}

document.addEventListener("DOMContentLoaded", function() {
    navbarDropdownHover();
    animationOnHover();
});

// export
export { bootstrap }
// export { gsap }